import isArray from 'lodash.isarray';
import isObject from 'lodash.isobject';

// eslint-disable-next-line
const removeObjectParentReferences = (obj: any) => {
  // eslint-disable-next-line
  delete obj.$$$nodeName;
  // eslint-disable-next-line
  delete obj.$$$parentNode;

  if (isArray(obj)) {
    obj.forEach(removeObjectParentReferences);
  } else {
    Object.keys(obj).forEach((key: string) => {
      if ((isObject(obj[key]) || isArray(obj[key])) && key !== 'condition') {
        removeObjectParentReferences(obj[key]);
      }
    });
  }
};

export default removeObjectParentReferences;
